import { Injectable } from '@angular/core';
import { User } from '../types/user.types';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UserService {
    public user: User;

    constructor(private httpClient: HttpClient) {}

    getUser(): undefined | User {
        const userString = sessionStorage.getItem('user');
        if (typeof userString !== 'string') {
            return undefined;
        }
        this.user = JSON.parse(userString);
        return this.user;
    }

    async getSystemAccessInfo(usr_id: string, uid: string) {
        return this.getAccessInfo('system_access', usr_id, uid);
    }

    async getBackupAccessInfo(usr_id: string, uid: string) {
        return this.getAccessInfo('backup_access', usr_id, uid);
    }

    private async getAccessInfo(option: string, usr_id: string, uid: string) {
        const formData = new FormData();
        formData.append('usr_id', usr_id);
        formData.append('option', option);
        try {
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/ajax_navigator.php?page=pages/api/Ajax_user_data.php&uid=${uid}&page_type=json`,
                    formData,
                    {
                        observe: 'response',
                    }
                )
            );

            return data.body.result;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
